import React, { useState, useEffect, useRef } from 'react';
import useTable from "../useTable";
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';
import axios from 'axios';
import moment from 'moment';
import { ModalEnterarFondosTerceros } from './modalEnterarFondoTercero';
import ValidarUsuario from '../comun/modalValidarUsuario';
import { Input } from '../../ui/inputs/Input';
import { PrimaryButton } from '../../ui/buttons/Button';

const TablaEnterarSolicitud = (props) => {

    var op = require('../../../src/modulos/datos')
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));
    //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
    const norden = true;
    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'COD. ORDEN', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'FECHA', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'PROVEEDOR', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'OPCIONES', textAlign: 'center' },
    ]
    const [mostrar2, setMostrar2] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [operacion, setOperacion] = useState(0);
    const [ordenPago, setOrdenPago] = useState();
    const [mostrarUsuario, setMostrarUsuario] = useState(false);
    const [ordenp, setOrdenp] = useState();
    const txtBuscador = useRef()
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTable(records, headCells, filterFn);
    const handleSearch = e => {
        let target = e.target;
        setFilterFn({
            fn: items => {
                if (target.value === "")
                    return items;
                else
                    return items.filter(x => {

                        if ((norden ? x.numordenpago.includes(target.value) : x.idordenpago.includes(target.value))
                            || x.proveedor.toLowerCase().includes(target.value.toLowerCase())
                            || moment.utc(x.fecha).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase())
                        ) {
                            return x;
                        }
                    });
            }
        })
    }

    const seleccionarRegistros = () => {
        setOrdenPago();
        let orden = '';
        let ubi = "42, 44, 46, 48, 49"
        if (norden) {
            orden = 'numordenpago desc';
        } else {
            orden = 'idordenpago desc';
        }
        let condic = "true";
        let endpoint = `${op.conexion}/api/administracion/seleccionarordenpago2?idefiscal=${idefiscal}&ubic=${ubi}&tip=${2}&orden=${orden}&condic=${condic}`;
        setActivate(true);
        console.log(endpoint)
        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status == 200) {
                setRecords(response.data);
            }
            setActivate(false)
        }).catch(function (error) {
            setActivate(false);
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        })
    }
    const seleccionarOrdenPagoFTercero = (dat, ope) => {
        let id = norden ? dat.numordenpago : dat.idordenpago;
        let campos = '*';
        let nomtab = 'ordenpago';
        let nomid = 'idefiscal';
        let condic = espiritu === 9 || espiritu === 12 || espiritu === 13 || espiritu === 14 || espiritu === 15 ? 'numordenpago = ' + id + ' AND tipo = 2' : 'idordenpago = ' + id;

        let endpoint = `${op.conexion}/api/consulta/modelicondi?campos=${campos}&id=${idefiscal}&nomtab=${nomtab}&nomid=${nomid}&condic=${condic}`

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {
            if (response.status == 200) {
                if (response.data.length > 0) {
                    if (response.data[0].ubicacion !== '42' && ope !== 4) {
                        let mensa = '';
                        switch (response.data[0].ubicacion) {
                            case '43':
                              mensa = 'La Orden de Pago se Encuentra en Contabilidad';
                              break;
                            case '44':
                                mensa = 'La Orden de Pago se Encuentra en Tesoreria por Cheque';
                              break;
                            case '45':
                                mensa = 'La Orden de Pago se Encuentra en Despacho';
                              break;
                            case '46':
                                mensa = 'La Orden de Pago se Encuentra en Tesoreria por Pago';
                              break;
                            case '48':
                                mensa = 'La Orden de Pago fue Pagada';
                              break;
                            case '49':
                                mensa = 'La Orden de Pago se Encuentra en Administración por Firma de Cheque';
                              break;
                            case '50':
                                mensa = 'La Orden de Pago se Encuentra en Administración por Autorizar Pago';
                              break;
                            default:
                              break;
                        }
                        setMensaje({ mostrar: true, titulo: 'Informacion.', texto: mensa, icono: 'informacion' });
                    } else {
                        setOrdenPago(response.data[0]);
                        setMostrar2(true);
                    }
                } else {
                    setOrdenPago();
                }
            }
        }).catch((error) => {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);
        })
    };
    const handleCloseSi = () => {
        setActivate(false);
    };

    const gestionarOrdenPago = (op, data) => (e) => {
        if (op === 4) {
            setOperacion(4);
            seleccionarOrdenPagoFTercero(data, op);
          } else if (op === 1) {
            setOperacion(op);
            setMostrar2(true)
          } else if (op === 2) {
            if (data.reversado > 0) {
              setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden de Pago ya fue Reversada', icono: 'informacion' });
            } else if (data.status === 1) {
              setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden de Pago ya fue Pagada', icono: 'informacion' });
            } else {
              setOperacion(op);
              seleccionarOrdenPagoFTercero(data, op);
            }
          } else if (op === 3) {
            if (data.reversado === 0) {
              setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La orden de pago no ha sido Reversada', icono: 'informacion' });
            } else if (data.status === 1) {
              setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'La Orden de Pago ya fue Pagada', icono: 'informacion' });
            } else {
              setOrdenp(data);
              setMostrarUsuario(true)
            }
          } else if (op === 5) {
            if (data.reversado > 0) {
              setOperacion(op);
              seleccionarOrdenPagoFTercero(data.idordenpago, op);
            } else {
              setMensaje({ mostrar: true, titulo: 'Informacion.', texto: 'Debe Reversar La Orden de Pago para poder Eliminar el Registro', icono: 'informacion' });
            }
          }
    }


    useEffect(() => {
        seleccionarRegistros();
        setActivate(true);
    }, []);

    const handleCancelar = () => {
        setOrdenPago();
        setMostrar2(false);
    }
    const cerrar = () => {
        props.setTabla(0)
    }

    const aceptaClaveSupervisor = () => {
        setMostrarUsuario(false);
        setOperacion(3);
        seleccionarOrdenPagoFTercero(ordenp, 3);
    }

    return (
        <div className='col-8 m-0 p-0 mx-auto mt-5'>
            <header className='col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top'>
                <h3 className='m-0'>
                    Gestionar Enterar Fondos de Terceros
                </h3>
                <a type='button' onClick={cerrar}>
                    salir<i className="fas fa-times ms-2"></i>
                </a>
            </header>
            <form onSubmit={(e)=>{e.preventDefault()}} 
                className="col-12 m-0 p-2 d-flex justify-content-between">
                <div className='col-4 m-0 p-0'>
                    <input 
                        ref={txtBuscador} 
                        onChange={handleSearch} 
                        placeholder="Buscar"
                        className='search-input form-control form-control-sm' />
                </div>
                <PrimaryButton onClick={gestionarOrdenPago(1, '')} icon='fa-plus m-0'> 
                </PrimaryButton>
            </form>
            <div >
                <TblContainer>
                    <TblHead />
                    <tbody>
                        {
                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                <tr key={index} style={{ padding: "0" }}>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '30px' }}>{norden ? item.numordenpago : item.idordenpago}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '50px' }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '300px' }}>{item.proveedor}</td>
                                    <td className='align-baseline' style={{ textAlign: "center", alignItems: 'center', width: '100px' }}>
                                        <button onClick={gestionarOrdenPago(4, item)} className="btn btn-sm mx-1 btn-info rounded-circle" ><i className="fas fa-eye"></i></button>
                                        <button onClick={gestionarOrdenPago(2, item)} className="btn btn-sm mx-1 btn-success rounded-pill"><i className="fas fa-sync-alt"></i></button>
                                        <button onClick={gestionarOrdenPago(3, item)} className="btn btn-sm mx-1 btn-danger rounded-circle" title='Eliminar Orden de Pago'><i className="fa fa-trash-alt"></i></button>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </TblContainer>
                <TblPagination />
            </div>
            <ValidarUsuario
                show={mostrarUsuario}
                onHideCancela={() => { setMostrarUsuario(false) }}
                onHideConfirmar={aceptaClaveSupervisor}
                llamado={0}
            />
            <ModalEnterarFondosTerceros
                show={mostrar2}
                operacion={operacion}
                norden={norden}
                ordenp={ordenPago}
                titulo={operacion === 4 ? 'Consultar Orden Pago' : operacion === 2 ? 'Reversar Orden Pago' : operacion === 1 ? 'Incluir Orden Pago' : 'Eliminar Orden Pago'}
                onHideCancelar={handleCancelar}
                onHideRenderizar={seleccionarRegistros}
            />

            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
        </div>
    );
}
export default TablaEnterarSolicitud;